/* eslint-disable */
import React, { useContext, useEffect, useState, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';
import CmsContext from 'context/CmsContext';
import { ModalContext } from 'App';
import Select from 'react-select';
import NumberFormat from 'react-number-format';
import Address from 'modules/common/address/Address';
import Citizenship from 'modules/BPLS/container/applications/components/Citizenship';
import Decimal from 'decimal.js';
import { MAX_LIMIT } from 'modules/common/constants';
import { get } from 'session';
import { ucwords } from 'helper';
import * as c from '../constant';
import * as actions from '../action';
import moment from 'moment';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import LeafletMap from 'modules/common/components/LeafletMap';

function BusinessModal({
  createNewBusinesses,
  getNewBusinessesList,
  history,
  id,
  getSingleNewBusinesses,
  creating,
  ordinanceRevisionId,
  createUploader,
  getVeterinaryFeeList,
  veterinaryFeeList,
  type,
  newBusinessesInfo,
  updateNewBusinesses,
  updating,
  getBusinessNecessaryField,
  businessNecessaryField,
}) {
  const [formData, setFormData] = useState({
    id: '',
    business_name: '',
    trade_name: '',
    cellphone_no: '',
    telephone_no: '',
    email_address: '',
    nationality: '',
    tin_no: '',
    kind_of_ownership: '',
    cda_no: '',
    dti_no: '',
    sec_no: '',

    main_office_region_code: '',
    main_office_province_code: '',
    main_office_municipality_code: '',
    main_office_barangay_code: '',
    main_office_street: '',
    main_office_zip_code: '',

    area: '',
    floor_area: '',
    base_line: '',
    no_of_employees: '',
    no_of_employees_residing_manila: '',
    no_of_male_employees: '',
    no_of_female_employees: '',
    no_of_vehicles: '',
    no_of_van: '',
    no_of_truck: '',
    no_of_motorcycle: '',

    incharge_first_name: '',
    incharge_last_name: '',
    incharge_middle_name: '',
    incharge_suffix_name: '',
    owners_gender: '',

    region_code: '130000000',
    province_code: '133900000',
    municipality_code: '',
    barangay_code: '',
    street: '',
    zip_code: '',
    location_owned: 0,
    tdn_no: '',
    pin_no: '',
    monthly_rental: '',
    with_tax_incentives: '',
    tax_incentives_attachment_url: '',
    activity_type: '',
    lessor_name: '',
    pinned_geolocation: '',
    veterinary_fee_id: '',
    dti_registration_expiry_date: '',
  });
  const cmsContext = useContext(CmsContext);
  const CMS_MASKINGS = cmsContext.findByType('MASKINGS');
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES');
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');
  const formIsPinSelected = _.get(formData, 'pin_selected');
  const formIsTdnSelected = _.get(formData, 'tdn_selected');
  const bplsPin19DigitRegex = _.get(
    CMS_MASKINGS,
    'BPLS_E2E_PIN_19_DIGIT_REGEX'
  );
  const bplsPin19Digit = _.get(CMS_MASKINGS, 'BPLS_E2E_PIN_19_DIGIT');
  const bplsPinRegex = _.get(CMS_MASKINGS, 'BPLS_E2E_PIN_REGEX');
  const bplsPin = _.get(CMS_MASKINGS, 'BPLS_E2E_PIN');
  const defaultPin19Digit = _.get(
    CMS_MASKINGS,
    'DEFAULT_BPLS_E2E_PIN_19_DIGIT'
  );
  const defaultPin = _.get(CMS_MASKINGS, 'DEFAULT_BPLS_E2E_PIN');
  const bplsTdnRegex = _.get(CMS_MASKINGS, 'BPLS_E2E_TDN_REGEX');
  const bplsTdn = _.get(CMS_MASKINGS, 'BPLS_E2E_TDN');
  const defaultTdn = _.get(CMS_MASKINGS, 'DEFAULT_BPLS_E2E_TDN');
  const [formDataBusinessNecessaryField, setFormDataBusinessNecessaryField] =
    useState({});
  const [businessNecessaryData, setBusinessNecessaryData] = useState({});
  const filteredBusinessNecessaryField = businessNecessaryField.filter(
    (item) => !item.quantity_matrix
  );
  const filteredQuantityMatrix = businessNecessaryField.filter(
    item => _.isArray(item.quantity_matrix) && item.quantity_matrix.length > 0
  );
  const quantityMatrixValue = _.get(
    formDataBusinessNecessaryField,
    'quantity_matrix',
    {}
  );
  const formPinnedLocation = _.get(formData, 'pinned_geolocation', '');
  const defaultLat = +get(CMS_COMPONENTS, 'BPLS_PINNED_LOCATION_LATITUDE', 0);
  const defaultLng = +get(CMS_COMPONENTS, 'BPLS_PINNED_LOCATION_LONGITUDE', 0);
  
  const selectedCoords = useMemo(() => {
    const defaultCoords = {
      lat: defaultLat,
      lng: defaultLng,
    };

    if (!formPinnedLocation) return defaultCoords;

    const [lat, lng] = formPinnedLocation.split(',');
    return {
      lat: +lat,
      lng: +lng,
    };
  }, [formPinnedLocation]);

  useEffect(() => {
    if (!_.isEmpty(businessNecessaryField)) {
      setFormData((prev) => ({
        ...prev,
        details: formDataBusinessNecessaryField,
      }));
    }
  }, [JSON.stringify(formDataBusinessNecessaryField)]);

  let commonValidation = {
    kind_of_ownership: 'required',
    owners_gender:
      'required_if:kind_of_ownership=ONE PERSON CORPORATION|required_if:kind_of_ownership=SOLE PROPRIETORSHIP',
    business_name: 'required|max_200_char',
    trade_name: 'max_200_char',
    dti_no:
      'required_if:kind_of_ownership=SOLE PROPRIETORSHIP|min_5_char|max_20_char',
    sec_no:
      'required_if:kind_of_ownership=CORPORATION|required_if:kind_of_ownership=ONE PERSON CORPORATION|required_if:kind_of_ownership=PARTNERSHIP|min_5_char|max_20_char',
    cda_no: 'required_if:kind_of_ownership=COOPERATIVE|min_5_char|max_20_char',
    cellphone_no: 'required|cellphone_number',
    email_address: 'required|email',
    municipality_code: 'required',
    barangay_code: 'required',
    zip_code: 'required|number',
    incharge_first_name: 'required',
    incharge_last_name: 'required',
    nationality:
      'required_if:kind_of_ownership=ONE PERSON CORPORATION|required_if:kind_of_ownership=PARTNERSHIP|required_if:kind_of_ownership=CORPORATION',
    area: 'required|number',
    floor_area: 'required|number',
    base_line: 'required|number',
    no_of_male_employees: 'required|number',
    no_of_female_employees: 'required|number',
    no_of_employees_residing_manila: 'required|number',
    no_of_van: 'required|number',
    no_of_truck: 'required|number',
    no_of_motorcycle: 'required|number',
    main_office_municipality_code: 'required',
    main_office_barangay_code: 'required',
    main_office_zip_code: 'required|number',
    tdn_no: 'required_if:tdn_selected=1|min_5_char|max_20_char',
    pin_no: 'required_if:pin_selected=1|min_5_char|max_20_char',
    lessor_name: 'required_if:location_owned=0',
    monthly_rental: 'required_if:location_owned=0',
    with_tax_incentives: 'required',
    tax_incentives_attachment_url: 'required_if:with_tax_incentives=1',
    activity_type: 'required',
    dti_registration_expiry_date: 'required_if:kind_of_ownership=SOLE PROPRIETORSHIP',
  };

  const validateForm = useFormValidator(formData, commonValidation);

  const validateFormBusinessNecessary = useFormValidator(
    formDataBusinessNecessaryField,
    businessNecessaryData
  );

  const validateBusinessNecessary = Object.keys(formDataBusinessNecessaryField)
    .map((item) => {
      return { [item]: 'required' };
    })
    .values();

  const setValidateBusinessNecessary = () => {
    // eslint-disable-next-line no-restricted-syntax
    for (const value of validateBusinessNecessary) {
      setBusinessNecessaryData((prevData) => ({
        ...prevData,
        ...value,
      }));
    }
  };

  useEffect(() => {
    setValidateBusinessNecessary();
  }, [JSON.stringify(formDataBusinessNecessaryField)]);

  const onChangeBusinessNecessaryField = (e) => {
    setFormDataBusinessNecessaryField({
      ...formDataBusinessNecessaryField,
      [e.target.name]: e ? e.target.value : '',
    });
  };

  const onChangeBusinessNecessaryQuantityMatrix = (key, value) => {
    setFormDataBusinessNecessaryField((prev) => ({
      ...prev,
      quantity_matrix: {
        ...prev.quantity_matrix,
        [key]: value,
      },
    }));
  };

  const onSelectDetails = (key) => (e) => {
    setFormDataBusinessNecessaryField((prevDetail) => ({
      ...prevDetail,
      [key]: e.value,
    }));
  };

  useEffect(() => {
    const defaultPinMask = defaultPin
      ? 'required_if:pin_selected=1|min_5_char|max_20_char'
      : `required_if:pin_selected=1|mask:${bplsPinRegex}~${bplsPin}`;
    const defaultPin19DigitMask = defaultPin19Digit
      ? 'required_if:pin_selected=1|min_5_char|max_20_char'
      : `required_if:pin_selected=1|mask:${bplsPin19DigitRegex}~${bplsPin19Digit}`;

    if (!formIsPinSelected && defaultPin && defaultPin19Digit) return;

    validateForm.onSetObjectRules({
      ...commonValidation,
      pin_no: _.get(formData, 'pin_format')
        ? defaultPin19DigitMask
        : defaultPinMask,
    });
  }, [formIsPinSelected, _.get(formData, 'pin_format')]);

  useEffect(() => {
    if (formIsTdnSelected && !defaultTdn) {
      validateForm.onSetObjectRules({
        ...commonValidation,
        tdn_no: `required_if:tdn_selected=1|mask:${bplsTdnRegex}~${bplsTdn}`,
      });
    }
  }, [formIsTdnSelected]);

  const setModal = useContext(ModalContext);

  useEffect(() => {
    getBusinessNecessaryField({
      application_status_id: get('applicationStatusId') || 0,
    });
  }, []);

  useEffect(() => {
    getVeterinaryFeeList();
  }, []);

  const findGenderValue =
    c.OWNERS_GENDER.find(
      (item) => _.get(formData, 'owners_gender') === _.get(item, 'value')
    ) || '';

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (!validateForm.response.is_passed) {
      return false;
    }

    const args = {
      ...formData,
      dti_no: _.get(formData, 'dti_no').toUpperCase(),
      sec_no: _.get(formData, 'sec_no').toUpperCase(),
      ordinance_revision_id: ordinanceRevisionId,
      dti_registration_expiry_date: _.get(formData, 'dti_registration_expiry_date') !== null
        && _.get(formData, 'dti_registration_expiry_date') !== ''
        && _.get(formData, 'dti_registration_expiry_date') !== 'Invalid date'
          ? moment(_.get(formData, 'dti_registration_expiry_date', '')).format('YYYY-MM-DD')
          : ''
    };

    if (type === 'NEW') {
      createNewBusinesses(args, ({ data }) => {
        setModal({ isOpen: false });
        getNewBusinessesList({ ordinance_revision_id: ordinanceRevisionId });
        history.push(`/bpls/new-business/new-businesses/${_.get(data, 'id')}`);
        getSingleNewBusinesses(data.id);
      });
    }
    return updateNewBusinesses(id, args, ({ data }) => {
      setModal({ isOpen: false });
      getNewBusinessesList({ ordinance_revision_id: ordinanceRevisionId });
      history.push(`/bpls/new-business/new-businesses/${_.get(data, 'id')}`);
      getSingleNewBusinesses(data.id);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChangeRadioLocationOwned = (e) => {
    if (e.target.value === '1') {
      setFormData({
        ...formData,
        [e.target.name]: +e.target.value,
        lessor_name: '',
        monthly_rental: '0.00',
        tdn_selected: 1,
        pin_format: 0,
      });
    }

    if (e.target.value === '0') {
      setFormData({
        ...formData,
        [e.target.name]: +e.target.value,
        pin_no: '',
        tdn_no: '',
        pin_selected: 0,
        tdn_selected: 0,
      });
    }

    return null;
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });

    if (key === 'kind_of_ownership') {
      setFormData({
        ...formData,
        [key]: e ? e.value : '',
        dti_no: '',
        sec_no: '',
        cda_no: '',
        dti_registration_expiry_date: '',
      });
    }
  };

  const onChangeRadio = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: +e.target.value,
    });
  };

  const onChangeCheckbox = (e) => {
    if (e.target.name === 'pin_selected') {
      if (e.target.checked) {
        setFormData((prevForm) => ({
          ...prevForm,
          tdn_no: '',
          pin_selected: 1,
          tdn_selected: 0,
        }));
      }

      if (!e.target.checked) {
        setFormData((prevForm) => ({
          ...prevForm,
          pin_no: '',
          pin_selected: 0,
          tdn_selected: 1,
          pin_format: 0,
        }));
      }
    }
  };

  const handleOnChangeRadio = (e) => {
    if (e.target.value !== 'others') {
      setFormData({
        ...formData,
        activity_type: e.target.value,
        activity_type_others: '',
      });
    }
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  useEffect(() => {
    if (!_.isEmpty(newBusinessesInfo)) {
      const businessDetails = _.get(
        newBusinessesInfo,
        'attributes.details',
        {}
      );
      const { quantity_matrix, ...businessDetail } = businessDetails;
      const multiplierQuantityMatrix = Object.entries(quantity_matrix || {}).reduce((acc, [, items]) => {
        items.forEach(({ multiplier, value }) => {
          acc[multiplier] = value;
        });
        return acc;
      }, {});

      const combinedDetails = {
        ...businessDetail,
        quantity_matrix: multiplierQuantityMatrix,
      };
      setFormDataBusinessNecessaryField((prev) => ({
        ...prev,
        ...combinedDetails,
      }));

      const checkNumberOfEmployees = (employeesData) => {
        if (
          _.get(newBusinessesInfo, 'attributes.no_of_employees') === 0 ||
          _.get(newBusinessesInfo, 'attributes.no_of_employees') === '0'
        )
          return '0';
        if (
          _.get(newBusinessesInfo, 'attributes.no_of_employees') !== 0 ||
          _.get(newBusinessesInfo, 'attributes.no_of_employees') !== '0'
        ) {
          if (
            (employeesData === 0 || employeesData === '0') &&
            (_.get(newBusinessesInfo, 'attributes.no_of_male_employees') !==
              0 ||
              _.get(newBusinessesInfo, 'attributes.no_of_female_employees') !==
                0)
          )
            return '0';
          if (
            (employeesData === 0 || employeesData === '0') &&
            (_.get(newBusinessesInfo, 'attributes.no_of_male_employees') ===
              0 ||
              _.get(newBusinessesInfo, 'attributes.no_of_female_employees') ===
                0)
          )
            return '';
        }
        return employeesData;
      };

      setFormData({
        ...formData,
        ..._.get(newBusinessesInfo, 'attributes.details'),
        business_name:
          _.get(newBusinessesInfo, 'attributes.business_name') || '',
        email_address:
          _.get(newBusinessesInfo, 'attributes.email_address') || '',
        bin: _.get(newBusinessesInfo, 'attributes.bin') || '',
        taxpayer_id: _.get(newBusinessesInfo, 'attributes.taxpayer_id') || '',
        cellphone_no: _.get(newBusinessesInfo, 'attributes.cellphone_no') || '',
        telephone_no: _.get(newBusinessesInfo, 'attributes.telephone_no') || '',
        tin_no: _.get(newBusinessesInfo, 'attributes.tin_no') || '',
        dti_no: _.get(newBusinessesInfo, 'attributes.dti_no') || '',
        sec_no: _.get(newBusinessesInfo, 'attributes.sec_no') || '',
        cda_no: _.get(newBusinessesInfo, 'attributes.cda_no') || '',
        kind_of_ownership:
          _.get(newBusinessesInfo, 'attributes.kind_of_ownership') || '',
        region_code: _.get(newBusinessesInfo, 'attributes.region_code') || '',
        province_code:
          _.get(newBusinessesInfo, 'attributes.province_code') || '',
        municipality_code:
          _.get(newBusinessesInfo, 'attributes.municipality_code') || '',
        barangay_code:
          _.get(newBusinessesInfo, 'attributes.barangay_code') || '',
        street: _.get(newBusinessesInfo, 'attributes.street') || '',
        zip_code: _.get(newBusinessesInfo, 'attributes.zip_code') || '',
        main_office_region_code:
          _.get(CMS_VARIABLES, 'REGION_CODE') ||
          _.get(newBusinessesInfo, 'attributes.main_office_region_code'),
        main_office_province_code:
          _.get(CMS_VARIABLES, 'PROVINCE_CODE') ||
          _.get(newBusinessesInfo, 'attributes.main_office_province_code'),
        main_office_municipality_code:
          _.get(CMS_VARIABLES, 'MUNICIPALITY_CODE') ||
          _.get(newBusinessesInfo, 'attributes.main_office_municipality_code'),
        main_office_barangay_code:
          _.get(newBusinessesInfo, 'attributes.main_office_barangay_code') ||
          '',
        main_office_street:
          _.get(newBusinessesInfo, 'attributes.main_office_street') || '',
        main_office_zip_code:
          _.get(newBusinessesInfo, 'attributes.main_office_zip_code') || '',
        area: _.get(newBusinessesInfo, 'attributes.area') || '',
        floor_area: _.get(newBusinessesInfo, 'attributes.floor_area') || '',

        no_of_employees:
          _.get(newBusinessesInfo, 'attributes.no_of_employees') === 0
            ? '0'
            : _.get(newBusinessesInfo, 'attributes.no_of_employees') || '',
        no_of_employees_residing_manila:
          checkNumberOfEmployees(
            _.get(
              newBusinessesInfo,
              'attributes.no_of_employees_residing_manila'
            )
          ) || '',
        no_of_male_employees:
          _.get(newBusinessesInfo, 'attributes.no_of_employees') === 0
            ? '0'
            : _.get(newBusinessesInfo, 'attributes.no_of_male_employees') ||
              '0',
        no_of_female_employees:
          _.get(newBusinessesInfo, 'attributes.no_of_employees') === 0
            ? '0'
            : _.get(newBusinessesInfo, 'attributes.no_of_female_employees') ||
              '0',
        no_of_vehicles:
          _.get(newBusinessesInfo, 'attributes.no_of_vehicles') || '0',
        no_of_van: _.get(newBusinessesInfo, 'attributes.no_of_van') || '0',
        no_of_truck: _.get(newBusinessesInfo, 'attributes.no_of_truck') || '0',
        no_of_motorcycle:
          _.get(newBusinessesInfo, 'attributes.no_of_motorcycle') || '0',
        incharge_first_name:
          _.get(newBusinessesInfo, 'attributes.incharge_first_name') || '',
        incharge_last_name:
          _.get(newBusinessesInfo, 'attributes.incharge_last_name') || '',
        incharge_middle_name:
          _.get(newBusinessesInfo, 'attributes.incharge_middle_name') || '',
        incharge_suffix_name:
          _.get(newBusinessesInfo, 'attributes.incharge_suffix_name') || '',
        owners_gender:
          _.get(newBusinessesInfo, 'attributes.owners_gender') || '',
        trade_name: _.get(newBusinessesInfo, 'attributes.trade_name') || '',
        nationality: _.get(newBusinessesInfo, 'attributes.nationality') || '',
        monthly_rental:
          _.get(newBusinessesInfo, 'attributes.monthly_rental', '') || '',
        lessor_name: _.get(newBusinessesInfo, 'attributes.lessor_name') || '',
        location_owned:
          _.get(newBusinessesInfo, 'attributes.location_owned') || 0,
        tdn_no: _.get(newBusinessesInfo, 'attributes.tdn_no') || '',
        pin_no: _.get(newBusinessesInfo, 'attributes.pin_no') || '',
        pin_selected: !_.isEmpty(_.get(newBusinessesInfo, 'attributes.pin_no'))
          ? 1
          : 0,
        tdn_selected: !_.isEmpty(_.get(newBusinessesInfo, 'attributes.tdn_no'))
          ? 1
          : 0,
        tax_incentives_attachment_url:
          _.get(
            newBusinessesInfo,
            'attributes.tax_incentives_attachment_url'
          ) || '',
        activity_type:
          _.get(newBusinessesInfo, 'attributes.activity_type') || '',
        activity_type_others:
          _.get(newBusinessesInfo, 'attributes.activity_type_others') || '',
        base_line:
          _.get(newBusinessesInfo, 'attributes.base_line') === 0
            ? '0'
            : _.get(newBusinessesInfo, 'attributes.base_line') || '',
        with_tax_incentives:
          _.get(newBusinessesInfo, 'attributes.with_tax_incentives') || 0,
        veterinary_fee_id:
          _.get(newBusinessesInfo, 'attributes.veterinary_fee_id') || '',
        pin_format: _.get(newBusinessesInfo, 'attributes.pin_format') ? 1 : 0,
        dti_registration_expiry_date: _.get(newBusinessesInfo, 'attributes.dti_registration_expiry_date') !== null 
          && _.get(newBusinessesInfo, 'attributes.dti_registration_expiry_date') !== '' 
          && _.get(newBusinessesInfo, 'attributes.dti_registration_expiry_date') !== 'Invalid date'
            ? moment(_.get(newBusinessesInfo, 'attributes.dti_registration_expiry_date', '')).format('MM-DD-YYYY')
            : '',
        pinned_geolocation: _.get(newBusinessesInfo, 'attributes.pinned_geolocation') || '',
      });
    }
  }, [JSON.stringify(newBusinessesInfo)]);

  // vet reg filter dropdown
  const listOption =
    veterinaryFeeList.map((item) => ({
      label: _.get(item, 'attributes.veterinary_registration'),
      value: _.get(item, 'id'),
    })) || '';

  const addedData = {
    label: 'Select',
    value: '',
  };

  const sortOption = (listOption || []).concat([addedData]);
  const vetRegistrationListOption = _.orderBy(sortOption, ['value'], ['asc']);

  const handlePinFormat = (e) => {
    if (e.target.checked) {
      setFormData({
        ...formData,
        pin_format: 1,
      });
    }

    if (!e.target.checked) {
      setFormData({
        ...formData,
        pin_no: _.get(formData, 'pin_no')?.replace(
          `/${_.get(CMS_MASKINGS, 'BPLS_E2E_DTI_NO_REGEX')}/`,
          '$1-$2-$3-$4-$5'
        ), // format pin_no into (000-00-000-000-000) // todo: add this to masking/cms for dynamic handling of pinformat
        pin_format: 0,
      });
    }
  };

  const onChangeBusinessAddress = (e) => {
    const values = _.get(e, 'target.value', {});
    const formattedValues = {
      main_office_region_code: _.get(values, 'region_code', ''),
      main_office_province_code: _.get(values, 'province_code', ''),
      main_office_municipality_code: _.get(values, 'municipality_code', ''),
      main_office_barangay_code: _.get(values, 'barangay_code', ''),
      main_office_zip_code: _.get(values, 'zip_code', ''),
      main_office_street: _.get(values, 'street', ''),
    };
    setFormData({
      ...formData,
      ...formattedValues,
    });
  };

  const onChangeTaxPayerAddress = (e) => {
    const values = _.get(e, 'target.value', {});
    setFormData({
      ...formData,
      ...values,
    });
  };

  const onChangeDate = (key) =>
    ({ target: { value } }) => {
      setFormData({
        ...formData,
        [key]: value,
      });
    };

  const selectOptions = (list) => {
    const newList = [];

    if (_.isEmpty(list)) return false;

    list.map((data) => {
      return newList.push({
        label: ucwords(_.get(data, 'multiplier'))
          .replace(/_/g, ' ')
          .replace(/^(.)|\s+(.)/g, (x) => x.toUpperCase()),
        value: data.multiplier,
      });
    });
    return newList;
  };

  const renderInputMaskConfigFromCms = (isPinSelected, pinFormat) => {
    if (isPinSelected && pinFormat) {
      return !defaultPin19Digit ? bplsPin19Digit : '';
    }

    if (isPinSelected && !pinFormat) {
      return !defaultPin ? bplsPin : '';
    }

    if (!isPinSelected && !pinFormat) {
      return !defaultTdn ? bplsTdn : '';
    }

    return '';
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row ml-auto text-primary font-weight-bold mb-2">
          Business Information and Registration
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Business Name: {validateForm.renderMessage('business_name')}
              </label>
              <input
                className="form-control"
                type="text"
                name="business_name"
                onChange={onChange}
                value={_.get(formData, 'business_name') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Business Identification Number (BIN):
              </label>
              <input
                className="form-control"
                type="text"
                name="business_name"
                onChange={onChange}
                value={_.get(formData, 'bin') || ''}
                disabled
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Trade Name / Franchise (If Applicable) :{' '}
                {validateForm.renderMessage('trade_name')}
              </label>
              <input
                className="form-control"
                type="text"
                name="trade_name"
                onChange={onChange}
                value={_.get(formData, 'trade_name') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Business Type:
                {validateForm.renderMessage('kind_of_ownership')}
              </label>
              <Select
                name="kind_of_ownership"
                placeholder="Select Module"
                onChange={handleOnChangeSelect('kind_of_ownership')}
                options={c.KIND_OF_OWNERSHIP}
                value={
                  c.KIND_OF_OWNERSHIP.find(
                    (item) =>
                      _.get(formData, 'kind_of_ownership') ===
                      _.get(item, 'value')
                  ) || ''
                }
              />
            </div>
            {formData.kind_of_ownership === 'SOLE PROPRIETORSHIP' && (
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  DTI Registration Number:{' '}
                  {validateForm.renderMessage('dti_no')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="dti_no"
                  style={{ textTransform: 'uppercase' }}
                  onChange={onChange}
                  value={_.get(formData, 'dti_no') || ''}
                />
              </div>
            )}
            {formData.kind_of_ownership === 'SOLE PROPRIETORSHIP' && (
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  DTI Registration Expiry Date:{' '}
                  {validateForm.renderMessage('dti_registration_expiry_date')}
                </label>
                <DateInputPicker
                  className="full-input"
                  onChange={onChangeDate('dti_registration_expiry_date')}
                  value={_.get(formData, 'dti_registration_expiry_date', '') || ''}
                />
              </div>
            )}
            {(formData.kind_of_ownership === 'CORPORATION' ||
              formData.kind_of_ownership === 'PARTNERSHIP' ||
              formData.kind_of_ownership === 'ONE PERSON CORPORATION') && (
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  SEC Registration Number:{' '}
                  {validateForm.renderMessage('sec_no')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="sec_no"
                  style={{ textTransform: 'uppercase' }}
                  onChange={onChange}
                  value={_.get(formData, 'sec_no') || ''}
                />
              </div>
            )}
            {formData.kind_of_ownership === 'COOPERATIVE' && (
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  CDA Registration Number:{' '}
                  {validateForm.renderMessage('cda_no')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="cda_no"
                  style={{ textTransform: 'uppercase' }}
                  onChange={onChange}
                  value={_.get(formData, 'cda_no') || ''}
                />
              </div>
            )}
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Tax Identification Number:{' '}
                {validateForm.renderMessage('tin_no')}
              </label>
              <InputMask
                placeholder={
                  _.get(CMS_MASKINGS, 'BPLS_E2E_TIN_NO_PLACEHOLDER') || ''
                }
                className="form-control"
                maskChar=" "
                mask={_.get(CMS_MASKINGS, 'BPLS_E2E_TIN_NO') || ''}
                autoComplete="none"
                id="tin_no"
                name="tin_no"
                onChange={onChange}
                value={_.get(formData, 'tin_no') || ''}
              />
            </div>
          </div>
        </div>
        <div className="row ml-auto text-primary font-weight-bold mb-2">
          Contact Information
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Email Address: {validateForm.renderMessage('email_address')}
              </label>
              <input
                className="form-control"
                type="text"
                name="email_address"
                onChange={onChange}
                value={_.get(formData, 'email_address') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Telephone Number:
              </label>
              <InputMask
                className="form-control"
                type="text"
                name="telephone_no"
                onChange={onChange}
                value={_.get(formData, 'telephone_no')}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Mobile Number: {validateForm.renderMessage('cellphone_no')}
              </label>
              <InputMask
                className="form-control"
                mask="639999999999"
                alwaysShowMask
                type="text"
                name="cellphone_no"
                onChange={onChange}
                value={_.get(formData, 'cellphone_no')}
              />
            </div>
          </div>
        </div>

        <div className="row ml-auto text-primary font-weight-bold mb-2">
          {`${
            ['ONE PERSON CORPORATION', 'PARTNERSHIP', 'CORPORATION'].indexOf(
              _.get(formData, 'kind_of_ownership')
            ) > -1
              ? 'PRESIDENT / OFFICER INCHARGE INFORMATION'
              : 'OWNER INFORMATION'
          } `}
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                First Name: {validateForm.renderMessage('incharge_first_name')}
              </label>
              <input
                className="form-control"
                type="text"
                name="incharge_first_name"
                onChange={onChange}
                value={_.get(formData, 'incharge_first_name') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Middle Name:
              </label>
              <input
                className="form-control"
                type="text"
                name="incharge_middle_name"
                onChange={onChange}
                value={_.get(formData, 'incharge_middle_name') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Last Name: {validateForm.renderMessage('incharge_last_name')}
              </label>
              <input
                className="form-control"
                type="text"
                name="incharge_last_name"
                onChange={onChange}
                value={_.get(formData, 'incharge_last_name') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Extension Name:
              </label>
              <Select
                name="incharge_suffix_name"
                placeholder="Select Module"
                onChange={handleOnChangeSelect('incharge_suffix_name')}
                options={c.EXTENSION_NAMES}
                value={
                  c.EXTENSION_NAMES.find(
                    (item) =>
                      _.get(formData, 'incharge_suffix_name') ===
                      _.get(item, 'value')
                  ) || ''
                }
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Sex: {validateForm.renderMessage('owners_gender')}
              </label>
              <Select
                isClearable
                name="owners_gender"
                placeholder="Select Sex"
                onChange={handleOnChangeSelect('owners_gender')}
                options={c.OWNERS_GENDER}
                value={findGenderValue}
              />
            </div>
            <div className="col-6 form-group">
              <label className="form-label mb-0">
                Country of Citizenship:{' '}
                {validateForm.renderMessage('nationality')}
              </label>
              <Citizenship
                name="nationality"
                onChange={onChange}
                value={_.get(formData, 'nationality') || ''}
              />
            </div>
          </div>
        </div>

        <div className="row ml-auto text-primary font-weight-bold mb-2">
          Taxpayer&apos;s Address
        </div>
        <div className="container-fluid">
          <Address
            required
            value={{
              region_code: _.get(formData, 'region_code') || '',
              province_code: _.get(formData, 'province_code') || '',
              municipality_code: _.get(formData, 'municipality_code') || '',
              barangay_code: _.get(formData, 'barangay_code') || '',
            }}
            onChange={onChangeTaxPayerAddress}
            region_name="region_code"
            province_name="province_code"
            municipality_name="municipality_code"
            barangay_name="barangay_code"
            name="tax_payer_address"
            withStreet={false}
            validatorMessage={validateForm.renderMessage}
            removeLabel
            regionDisabled={false}
            provinceDisabled={false}
            municipalityDisabled={false}
          />
          <div className="row mt-2">
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Address Line 1:
              </label>
              <input
                className="form-control"
                type="text"
                name="street"
                onChange={onChange}
                value={_.get(formData, 'street') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Zip Code: {validateForm.renderMessage('zip_code')}
              </label>
              <InputMask
                className="form-control"
                type="text"
                mask="9999"
                name="zip_code"
                onChange={onChange}
                value={_.get(formData, 'zip_code') || ''}
              />
            </div>
          </div>
        </div>

        <div className="row ml-auto text-primary font-weight-bold mb-2">
          Business Address
        </div>
        <div className="container-fluid">
          <Address
            required
            value={{
              region_code:
                _.get(CMS_VARIABLES, 'REGION_CODE') ||
                _.get(formData, 'main_office_region_code') ||
                '',
              province_code:
                _.get(CMS_VARIABLES, 'PROVINCE_CODE') ||
                _.get(formData, 'main_office_province_code') ||
                '',
              municipality_code:
                _.get(CMS_VARIABLES, 'MUNICIPALITY_CODE') ||
                _.get(formData, 'main_office_municipality_code') ||
                '',
              barangay_code: _.get(formData, 'main_office_barangay_code') || '',
            }}
            onChange={onChangeBusinessAddress}
            region_name="main_office_region_code"
            province_name="main_office_province_code"
            municipality_name="main_office_municipality_code"
            barangay_name="main_office_barangay_code"
            name="main_office"
            withStreet={false}
            validatorMessage={validateForm.renderMessage}
            removeLabel
            regionDisabled
            provinceDisabled
            municipalityDisabled
          />
          <div className="row mt-2">
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Address Line 1:{' '}
                {validateForm.renderMessage('main_office_street')}
              </label>
              <input
                className="form-control"
                type="text"
                name="main_office_street"
                onChange={onChange}
                value={_.get(formData, 'main_office_street') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                ZIP Code: {validateForm.renderMessage('main_office_zip_code')}
              </label>
              <InputMask
                className="form-control"
                type="text"
                mask="9999"
                name="main_office_zip_code"
                onChange={onChange}
                value={_.get(formData, 'main_office_zip_code') || ''}
              />
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-6 form-group mb-0 pb-0 d-flex flex-row align-items-center justify-content-between">
              <label htmlFor="last_name" className="form-label mr-2 mb-1">
                Location Owned:
              </label>
              <div className="d-flex flex-row justify-content-center px-0 mx-0">
                <div className="d-flex align-items-center">
                  <input
                    type="radio"
                    name="location_owned"
                    style={{ width: '20px', height: '20px' }}
                    onChange={onChangeRadioLocationOwned}
                    checked={_.get(formData, 'location_owned') === 1}
                    value="1"
                  />
                  <label className="full-label mb-0 mx-1">Yes</label>
                </div>
                <div className="d-flex align-items-center mr-2">
                  <input
                    type="radio"
                    name="location_owned"
                    style={{ width: '20px', height: '20px' }}
                    onChange={onChangeRadioLocationOwned}
                    checked={_.get(formData, 'location_owned') === 0}
                    value="0"
                  />
                  <label className="full-label mb-0 mx-1">No</label>
                </div>
              </div>
            </div>
          </div>
          <div className="col-6 form-group" />{' '}
          {/* placeholder only to avoid collapsing of ONWED? input */}
          {formData.location_owned === 1 ? (
            <div className="col-6 form-group px-0">
              <div className="row d-flex align-items-center justify-content-between">
                <div className="col-6">
                  <label className="form-label mb-0">
                    {formIsPinSelected !== 1
                      ? 'Tax Declaration No.'
                      : 'Property Identification No.'}{' '}
                    {formIsPinSelected !== 1
                      ? validateForm.renderMessage('tdn_no')
                      : validateForm.renderMessage('pin_no')}
                  </label>
                </div>
                <div className="col-6 text-right">
                  {formIsPinSelected ? (
                    <label className="form-label mb-0">
                      19-digit Format:
                      <input
                        name="pin_format"
                        type="checkbox"
                        checked={_.get(formData, 'pin_format') ? 1 : 0}
                        onChange={handlePinFormat}
                        className="mx-2 mb-2"
                      />
                    </label>
                  ) : null}
                  <label className="form-label mb-0">PIN:</label>
                  {/* checkbox */}
                  <input
                    className="mx-2 mb-2"
                    type="checkbox"
                    name="pin_selected"
                    onChange={onChangeCheckbox}
                    checked={formIsPinSelected}
                  />
                </div>
              </div>
              {/* input */}
              <InputMask
                className="form-control"
                placeholder=""
                mask={renderInputMaskConfigFromCms(
                  formIsPinSelected,
                  _.get(formData, 'pin_format')
                )}
                alwaysShowMask
                maskChar=""
                type="text"
                name={formIsPinSelected !== 1 ? 'tdn_no' : 'pin_no'}
                id={formIsPinSelected !== 1 ? 'tdn_no' : 'pin_no'}
                onChange={onChange}
                value={
                  formIsPinSelected !== 1
                    ? _.get(formData, 'tdn_no', '')?.toUpperCase()
                    : _.get(formData, 'pin_no', '')?.toUpperCase() || ''
                }
              />
            </div>
          ) : (
            <div className="row">
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  Lessor Name (if applicable):{' '}
                  {validateForm.renderMessage('lessor_name')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="lessor_name"
                  onChange={onChange}
                  value={_.get(formData, 'lessor_name') || ''}
                />
              </div>
              <div className="col-6 form-group">
                <label htmlFor="monthly_rental" className="form-label mb-0">
                  Monthly Rental: {validateForm.renderMessage('monthly_rental')}
                </label>
                <NumberFormat
                  name="monthly_rental"
                  id="monthly_rental"
                  placeholder="0.00"
                  className="form-control"
                  onValueChange={(values) => {
                    const { value } = values;
                    setFormData({
                      ...formData,
                      monthly_rental: value,
                    });
                  }}
                  displayType="input"
                  decimalScale={2}
                  isNumericString
                  allowNegative
                  thousandSeparator
                  allowLeadingZeros
                  prefix="₱ "
                  value={_.get(formData, 'monthly_rental')}
                  isAllowed={(values) => {
                    const { value } = values;
                    if (!value) return true;
                    const val = new Decimal(value);
                    const max = new Decimal(MAX_LIMIT);
                    return value === undefined || val.lte(max);
                  }}
                />
              </div>
            </div>
          )}
          <div
            style={{ height: '300px', width: '100%' }}
            className="mt-3 d-flex flex-column"
          >
            <LeafletMap
              pins={[selectedCoords]}
              center={[selectedCoords.lat, selectedCoords.lng]}
              zoom={17}
              showSearch
              onMapClick={(newPin) => {
                setFormData((prevForm) => ({
                  ...prevForm,
                  pinned_geolocation: `${newPin.latlng.lat},${newPin.latlng.lng}`,
                }));
              }}
            />
          </div>
        </div>
        <div className="row ml-auto text-primary font-weight-bold mb-2">
          Business Operations
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-6 form-group">
              <label htmlFor="floor_area" className="form-label mb-0">
                Total Floor Area (sq.m):{' '}
                {validateForm.renderMessage('floor_area')}
              </label>
              <NumberFormat
                name="floor_area"
                id="floor_area"
                placeholder="0.00"
                className="form-control"
                onValueChange={(values) => {
                  const { value } = values;
                  const floorArea = Number(value || 0);
                  const areaValue = Number(_.get(formData, 'area') || 0);
                  setFormData({
                    ...formData,
                    floor_area: value,
                    area:
                      floorArea > 0 && areaValue > floorArea
                        ? value
                        : _.get(formData, 'area', ''),
                  });
                }}
                displayType="input"
                decimalScale={2}
                isNumericString
                allowNegative
                thousandSeparator
                allowLeadingZeros
                value={_.get(formData, 'floor_area')}
                isAllowed={(values) => {
                  const { value } = values;
                  if (!value) return true;
                  const val = new Decimal(value);
                  const max = new Decimal(MAX_LIMIT);
                  return value === undefined || val.lte(max);
                }}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="area" className="form-label mb-0">
                Business Area (sq.m):{' '}
                {validateForm.renderMessage('area')}
              </label>
              <NumberFormat
                name="area"
                id="area"
                placeholder="0.00"
                className="form-control"
                onValueChange={(values) => {
                  const { value } = values;
                  const floorArea = Number(_.get(formData, 'floor_area') || 0);
                  const areaValue = Number(value || 0);
                  const nextArea =
                    floorArea > 0 && areaValue > floorArea ? _.get(formData, 'floor_area') : value;
                  setFormData({
                    ...formData,
                    area: nextArea,
                  });
                }}
                displayType="input"
                decimalScale={2}
                isNumericString
                allowNegative
                thousandSeparator
                allowLeadingZeros
                value={_.get(formData, 'area')}
                isAllowed={(values) => {
                  const { value } = values;
                  if (!value) return true;
                  const val = new Decimal(value);
                  const max = new Decimal(MAX_LIMIT);
                  return value === undefined || val.lte(max);
                }}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                No. of Employees residing within Area:{' '}
                {validateForm.renderMessage('no_of_employees_residing_manila')}
              </label>
              <input
                className="form-control"
                type="number"
                name="no_of_employees_residing_manila"
                onChange={onChange}
                value={_.get(formData, 'no_of_employees_residing_manila') || ''}
                required
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                No. of Male Employees:{' '}
                {validateForm.renderMessage('no_of_male_employees')}
              </label>
              <input
                className="form-control"
                type="number"
                name="no_of_male_employees"
                onChange={onChange}
                value={_.get(formData, 'no_of_male_employees') || ''}
                required
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                No. of Female Employees:{' '}
                {validateForm.renderMessage('no_of_female_employees')}
              </label>
              <input
                className="form-control"
                type="number"
                name="no_of_female_employees"
                onChange={onChange}
                value={_.get(formData, 'no_of_female_employees') || ''}
                required
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                No. of Van Delivery Vehicles (0 if not applicable):{' '}
                {validateForm.renderMessage('no_of_van')}
              </label>
              <input
                className="form-control"
                type="number"
                name="no_of_van"
                onChange={onChange}
                value={_.get(formData, 'no_of_van') || ''}
                required
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                No. of Truck Delivery Vehicles (0 if not applicable):{' '}
                {validateForm.renderMessage('no_of_truck')}
              </label>
              <input
                className="form-control"
                type="number"
                name="no_of_truck"
                onChange={onChange}
                value={_.get(formData, 'no_of_truck') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                No. of Motorcycle Delivery Vehicles (0 if not applicable):{' '}
                {validateForm.renderMessage('no_of_motorcycle')}
              </label>
              <input
                className="form-control"
                type="number"
                name="no_of_motorcycle"
                onChange={onChange}
                value={_.get(formData, 'no_of_motorcycle') || ''}
              />
            </div>

            {filteredBusinessNecessaryField.map((item, i) => {
              return (
                <React.Fragment key={i}>
                  {_.get(item, 'options') ? (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={i} className="col-6 form-group">
                      <label className="form-label mb-0">
                        {ucwords(_.get(item, 'multiplier') ?? '').replace(
                          /_/g,
                          ' '
                        )}{' '}
                        {validateFormBusinessNecessary.renderMessage(
                          `${_.get(item, 'multiplier')}`
                        )}
                      </label>
                      <Select
                        name={_.get(item, 'multiplier')}
                        options={selectOptions(_.get(item, 'options'))}
                        value={
                          selectOptions(_.get(item, 'options')).find(
                            (option) => {
                              return (
                                _.get(
                                  formDataBusinessNecessaryField,
                                  _.get(item, 'multiplier')
                                ) === _.get(option, 'value')
                              );
                            }
                          ) || ''
                        }
                        onChange={onSelectDetails(_.get(item, 'multiplier'))}
                        components={{ IndicatorSeparator: () => null }}
                      />
                    </div>
                  ) : (
                    ''
                  )}
                  {!_.get(item, 'options') ? (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={i} className="col-6 form-group">
                      <label htmlFor="last_name" className="form-label mb-0">
                        {ucwords(_.get(item, 'multiplier') ?? '').replace(
                          /_/g,
                          ' '
                        )}
                        :{' '}
                        {validateFormBusinessNecessary.renderMessage(
                          `${_.get(item, 'multiplier')}`
                        )}
                      </label>
                      <input
                        className="form-control"
                        type="number"
                        name={_.get(item, 'multiplier')}
                        onChange={onChangeBusinessNecessaryField}
                        value={
                          _.get(
                            formDataBusinessNecessaryField,
                            `${_.get(item, 'multiplier')}`
                          ) || ''
                        }
                      />
                    </div>
                  ) : (
                    ''
                  )}
                </React.Fragment>
              );
            })}
            {!_.isEmpty(filteredQuantityMatrix) ? (
              filteredQuantityMatrix.map((item) => {
                const multiplier = _.get(item, 'multiplier', '');
                
                return (
                  <React.Fragment>
                    <div className='form-group col-12 mb-0'>
                      <label className='form-label mb-0 text-capitalize'>
                        {multiplier}
                      </label>
                    </div>
                    <div className="w-100 border rounded-lg mx-3 mb-3">
                      <table className="table table-borderless table-sm table-striped table-hover mb-0">
                        <thead>
                          <tr className="form-group">
                            <td className="col-4 form-label text-center border-right">Unit</td>
                            <td className="col-4 form-label text-center border-right">Capacity</td>
                            <td className="col-4 form-label text-center">Number of Units</td>
                          </tr>
                        </thead>
                        <tbody>
                          {item.quantity_matrix.map((quantityMatrixItem) => {
                            const quantityMatrixMultiplier = _.get(quantityMatrixItem, 'multiplier');

                            return (
                              // eslint-disable-next-line react/no-array-index-key
                              <tr
                                key={quantityMatrixMultiplier}
                                className="border-top form-group"
                              >
                                <td className="col-4 text-left form-label border-right">
                                  {_.get(quantityMatrixItem, 'unit')}
                                </td>
                                <td className="col-4 text-left form-label border-right">
                                  {_.get(quantityMatrixItem, 'capacity')}
                                </td>
                                <td className="col-4 text-left form-label">
                                  <NumberFormat
                                    name={quantityMatrixMultiplier}
                                    id={quantityMatrixMultiplier}
                                    allowLeadingZeros
                                    className="form-control"
                                    onValueChange={(values) => {
                                      const { floatValue } = values;
                                      onChangeBusinessNecessaryQuantityMatrix(
                                        quantityMatrixMultiplier,
                                        floatValue
                                      );
                                    }}
                                    displayType="input"
                                    thousandSeparator
                                    isNumericString
                                    prefix=""
                                    value={quantityMatrixValue[quantityMatrixMultiplier]}
                                    placeholder="_"
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </React.Fragment>
                )
              })
              
            ) : (
              ''
            )}
          </div>
        </div>

        <div className="row ml-auto text-primary font-weight-bold mb-2">
          Calculation Details
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Veterinary Fee:
              </label>
              <Select
                options={vetRegistrationListOption}
                placeholder="Select Veterinary Fee"
                onChange={handleOnChangeSelect('veterinary_fee_id')}
                value={
                  vetRegistrationListOption.find((item) => {
                    return (
                      `${_.get(formData, 'veterinary_fee_id')}` ===
                      _.get(item, 'value')
                    );
                  }) || ''
                }
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Base Line: {validateForm.renderMessage('base_line')}
              </label>
              <input
                className="form-control"
                type="text"
                name="base_line"
                onChange={onChange}
                value={_.get(formData, 'base_line') || ''}
              />
            </div>
          </div>
        </div>
        <div className="row ml-auto text-primary font-weight-bold my-2">
          Business Activities{' '}
          <span className="px-1">
            {validateForm.renderMessage('activity_type')}
          </span>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 form-group d-flex flex-row align-items-center justify-content-between px-3 py-2 my-0">
              <input
                type="radio"
                name="activity_type"
                onChange={handleOnChangeRadio}
                checked={_.get(formData, 'activity_type') === 'MAIN OFFICE'}
                value="MAIN OFFICE"
              />
              <label className="form-label pr-3 m-0">Main Office</label>
              <input
                type="radio"
                name="activity_type"
                onChange={handleOnChangeRadio}
                checked={_.get(formData, 'activity_type') === 'BRANCH OFFICE'}
                value="BRANCH OFFICE"
              />
              <label className="form-label pr-3 m-0">Branch Office</label>
              <input
                type="radio"
                name="activity_type"
                onChange={handleOnChangeRadio}
                checked={
                  _.get(formData, 'activity_type') === 'ADMIN OFFICE ONLY'
                }
                value="ADMIN OFFICE ONLY"
              />
              <label className="form-label pr-3 m-0">Admin Office only</label>
              <input
                type="radio"
                name="activity_type"
                onChange={handleOnChangeRadio}
                checked={_.get(formData, 'activity_type') === 'WAREHOUSE'}
                value="WAREHOUSE"
              />
              <label className="form-label pr-3 m-0">Warehouse</label>
              <input
                type="radio"
                name="activity_type"
                onChange={handleOnChangeRadio}
                checked={_.get(formData, 'activity_type') === 'OTHERS'}
                value="OTHERS"
              />
              <label className="form-label pr-3 m-0">Others</label>
              <input
                className="col-4 custom-input"
                disabled={_.get(formData, 'activity_type') !== 'OTHERS'}
                type="text"
                name="activity_type_others"
                onChange={onChange}
                placeholder="Pls specify"
                value={_.get(formData, 'activity_type_others') || ''}
              />
            </div>
            <div className="col-12 form-group py-2">
              <label htmlFor="last_name" className="form-label mr-2 mb-1">
                Tax Incentives from any Government Entity:{' '}
                {validateForm.renderMessage('with_tax_incentives')}
              </label>
              <input
                type="radio"
                name="with_tax_incentives"
                onChange={onChangeRadio}
                checked={_.get(formData, 'with_tax_incentives') === 1}
                value="1"
              />
              <label className="form-label mx-2 mb-1">Yes</label>
              <input
                type="radio"
                name="with_tax_incentives"
                onChange={onChangeRadio}
                checked={_.get(formData, 'with_tax_incentives') === 0}
                value="0"
              />
              <label className="form-label mx-2 mb-1">No</label>
            </div>
            {formData.with_tax_incentives === 1 ? (
              <div className="col-12 form-group mb-3">
                <div className="w-25">
                  {createUploader(
                    {
                      key: 'tax_incentives_attachment_url',
                      label: 'Tax Incentive',
                    },
                    { required: true }
                  )}
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          {type === 'NEW' && (
            <button
              disabled={
                creating ||
                !validateForm.response.is_passed ||
                !validateFormBusinessNecessary.response.is_passed
              }
              type="submit"
              className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
            >
              <span className="font-weight-bold">
                {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
              </span>{' '}
            </button>
          )}
          {type === 'EDIT' && (
            <button
              disabled={
                updating ||
                !validateForm.response.is_passed ||
                !validateFormBusinessNecessary.response.is_passed
              }
              type="submit"
              className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
            >
              <span className="font-weight-bold">
                {updating ? <i className="fa fa-spin fa-spinner" /> : `Update`}
              </span>{' '}
            </button>
          )}
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

BusinessModal.defaultProps = {
  type: '',
  id: '',
  newBusinessesInfo: {},
};

BusinessModal.propTypes = {
  getNewBusinessesList: PropTypes.instanceOf(Function).isRequired,
  createNewBusinesses: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleNewBusinesses: PropTypes.instanceOf(Function).isRequired,
  createUploader: PropTypes.instanceOf(Function).isRequired,
  getVeterinaryFeeList: PropTypes.instanceOf(Function).isRequired,
  veterinaryFeeList: PropTypes.instanceOf(Array).isRequired,
  creating: PropTypes.bool.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
  id: PropTypes.string,
  type: PropTypes.string,
  newBusinessesInfo: PropTypes.instanceOf(Object),
  updateNewBusinesses: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  getBusinessNecessaryField: PropTypes.instanceOf(Function).isRequired,
  businessNecessaryField: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  creating: api.loading.indexOf(c.CREATE_NEW_BUSINESSES) > -1,
  veterinaryFeeList: _.get(api, `${c.GET_VETERINARY_FEE_LIST}.list`) || [],
  updating: api.loading.indexOf(c.UPDATE_NEW_BUSINESSES) > -1,
  businessNecessaryField:
    _.get(api, `${c.GET_BUSINESS_NECESSARY_FIELD}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(BusinessModal);
